import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const CTAConfigurationForm = ({ formData, onChange, errors }) => {
  const handleChange = (field) => (e) => {
    onChange({
      ...formData,
      [field]: e?.target?.value
    });
  };

  const ctaTypeOptions = [
    { value: 'quote', label: 'Request Quote', description: 'Direct customers to quote request form' },
    { value: 'contact', label: 'Contact Us', description: 'Link to contact page' },
    { value: 'phone', label: 'Call Now', description: 'Initiate phone call' },
    { value: 'custom', label: 'Custom URL', description: 'Link to any custom destination' }
  ];

  const ctaPositionOptions = [
    { value: 'header', label: 'Header (Top Right)' },
    { value: 'footer', label: 'Footer (Bottom)' },
    { value: 'both', label: 'Both Header & Footer' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-text-primary mb-1">Call-to-Action Settings</h3>
        <p className="text-sm text-text-secondary">
          Configure customer action buttons for lead generation optimization
        </p>
      </div>
      <div className="space-y-6">
        <Select
          label="CTA Type"
          description="Choose the primary action for customers"
          options={ctaTypeOptions}
          value={formData?.ctaType || 'quote'}
          onChange={(value) => onChange({ ...formData, ctaType: value })}
          required
        />

        <Input
          label="Button Text"
          type="text"
          placeholder="Get Free Quote"
          value={formData?.ctaButtonText || ''}
          onChange={handleChange('ctaButtonText')}
          error={errors?.ctaButtonText}
          required
          description="Text displayed on the CTA button (max 25 characters)"
          maxLength={25}
        />

        <Input
          label="Destination URL"
          type="url"
          placeholder="https://www.company.com/quote"
          value={formData?.ctaUrl || ''}
          onChange={handleChange('ctaUrl')}
          error={errors?.ctaUrl}
          required
          description="Where customers are directed when clicking the button"
        />

        <Select
          label="Button Position"
          description="Where the CTA button appears in the visualizer"
          options={ctaPositionOptions}
          value={formData?.ctaPosition || 'header'}
          onChange={(value) => onChange({ ...formData, ctaPosition: value })}
        />

        <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="Lightbulb" size={20} className="text-primary mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-text-primary mb-2">CTA Best Practices:</p>
              <ul className="text-xs text-text-secondary space-y-1 list-disc list-inside">
                <li>Use action-oriented language (Get, Request, Start, Schedule)</li>
                <li>Keep button text concise and clear (3-5 words)</li>
                <li>Ensure destination URL leads to a mobile-friendly page</li>
                <li>Test the complete customer journey from visualizer to conversion</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="p-4 bg-muted rounded-lg">
          <p className="text-xs font-medium text-text-secondary mb-3">Preview:</p>
          <div className="flex items-center justify-between p-3 bg-surface border border-border rounded-lg">
            <span className="text-sm text-text-secondary">Visualizer Header</span>
            <button
              className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium"
              disabled
            >
              {formData?.ctaButtonText || 'Get Free Quote'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTAConfigurationForm;